import {useQuery} from 'react-query';

import {useH5Preview} from 'src/hooks/h5/useH5Preview';
import {Project, fetchProject, listProjects} from 'src/lib/api/project';

type MaybeApiProject = Project | null | undefined;

type MaybeApiProjects = Project[] | null | undefined; //TODO: added undefined so type checking passed;

export function useProject(projectId: Project['id']): {
  project: MaybeApiProject;
} {
  const {enabled: h5Preview} = useH5Preview();
  const {data: project} = useQuery(
    h5Preview ? ['project', projectId, 'h5Preview'] : ['project', projectId],
    () => fetchProject(projectId, h5Preview)
  );
  return {project};
}

export function useProjects(): {
  projects: MaybeApiProjects;
  isLoaded: boolean;
} {
  const {data: projects, isLoading} = useQuery('projects', () => listProjects(), {
    cacheTime: 0,
  });

  return {projects, isLoaded: !isLoading};
}

export function useProjectsWithSites() {
  const {data: projects, isLoading} = useQuery(
    'projects',
    async () => {
      const projects = await listProjects();
      for (let i = 0; i < projects.length; i++) {
        const p = await fetchProject(projects[i].id);
        projects[i] = {...projects[i], ...p};
      }
      return projects;
    },
    {
      cacheTime: 0,
    }
  );

  return {projects, isLoaded: !isLoading};
}
